<template>
  <v-card flat color="rgb(243, 245, 248, .4)" rounded>
    <v-card-title>
      <h3 class="titleText--text">Variable standardization</h3>
    </v-card-title>
    <v-card-text>
      <v-simple-table fixed-header height="600" sortable="true">
        <template v-slot:default>
          <thead>
            <tr>
              <th style="background: rgb(243, 245, 248)" class="text-center titleText--text font-weight-bold">
                {{ "Name" | tableheader }}
              </th>
              <th style="background: rgb(243, 245, 248)" class="text-center titleText--text font-weight-bold">
                {{ "Function" | tableheader }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in listOfvarlistforstandardization" :key="item.id">
              <td style="background: rgb(243, 245, 248, .4)" class="text-left titleText--text font-weight-bold">{{ item.variable }}</td>
              <td style="background: rgb(243, 245, 248, .4)" class="text-right">
                <div style="width: 180px; float: right">
                  <v-select
                    @change="CallFunctionChangeEvent(item.function, item.variable)"
                    v-model="item.function"
                    :items="listoffunctions"
                    solo
                    placeholder="Select Function"
                    flat
                    dense
                    hide-details
                    style="border-radius: 8px; border: 2px solid #f3f5f8;"
                  ></v-select>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
import apifactory from "../api";
export default {
  data: () => ({
    listOffunctionforstandardization: [],
    listoffunctions: ["zscore", "divcm", "subcm", "divcmdvsubcm","none"],
    listOfvarlistforstandardization_temp: [],
    listOfvarlistforstandardization_data: [],
    listOfvarlistforstandardization: [],
    listOfsavedata: [],
  }),
  methods: {
    OnloadData() {
      //alert("CtrlVarstandardization");
    },
    CallFunctionChangeEvent(varfunction, varvariable) {
      if(varfunction == 'none')
      {
        this.CallFunctionChangeEvent_delete(varfunction, varvariable);
      }else{

        this.CallFunctionChangeEvent_save(varfunction, varvariable);
      }
     
    },
    CallFunctionChangeEvent_save(varfunction, varvariable) {
      apifactory
        .api_save_var_standardization(varvariable, varfunction)
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          }
          else{
            this.onmountmethod();
          }
        })
        .catch(function (error) {
          throw error;
        });
    },
       CallFunctionChangeEvent_delete(varfunction, varvariable) {
      apifactory
        .api_save_var_standardization_delete(varvariable, varfunction)
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          }
            else{
            this.onmountmethod();
          }
        })
        .catch(function (error) {
          throw error;
        });
    },
    getfunctionforstandardization() {
      try {
        this.listOffunctionforstandardization =
          apifactory.api_get_functionforstandardization();
      } catch (error) {
        throw error;
      }
    },
    getvariableList() {
      this.listOfvarlistforstandardization = [];
      apifactory
        .api_get_varlist_for_standardization()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.listOfvarlistforstandardization_temp = res.data.variable_list;
            let index = 1;
            for (var k in this.listOfvarlistforstandardization_temp) {
              let tempobj = new Object();
              tempobj.id = index;
              tempobj.variable = this.listOfvarlistforstandardization_temp[k];
              let templistfilter = this.listOfsavedata.filter(
                (a) => a.variable ==this.listOfvarlistforstandardization_temp[k]
              );
             // alert(JSON.stringify(templistfilter));
              if (templistfilter.length > 0) {
                 tempobj.function = templistfilter[0].function;
              } else {
                tempobj.function = "";
              }
             
              this.listOfvarlistforstandardization.push(tempobj);
              index = index + 1;
            }
          }
        })
        .catch(function (error) {
          throw error;
        });
    },
    getsaveddata() {
      this.listOfsavedata = [];
      apifactory
        .api_get_save_var_standardization()
        .then((res) => {
          //alert(JSON.stringify(res));

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
              if(res.data.status == 402){
                   this.listOfsavedata = [];
              }else{
 this.listOfsavedata = res.data;
              }
           
          }
        })
        .catch(function (error) {
          throw error;
        });
    },
    onmountmethod(){
      this.OnloadData();
    this.getfunctionforstandardization();
    this.getsaveddata();
    this.getvariableList();
    }
  },
  mounted() {
    this.onmountmethod();
 
  },
};
</script>
<style scoped>
  table td {
  border: none !important;
}

table thead, table tr {
  border: none !important
}
</style>
